import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  PeriodicAudit,
  API_PATH_PERIODIC_AUDIT,
} from './periodicAudit.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getPeriodicAuditList(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<PeriodicAudit>> {
  return http.get(`${API_PATH_PERIODIC_AUDIT}/${deliveryFunctionId}`);
}

export function getPeriodicAudit(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<PeriodicAudit>> {
  // api/v1/dfconfigs
  return http.get(`${API_PATH_PERIODIC_AUDIT}/${deliveryFunctionId}`);
}

export function updatePeriodicAudit(
  deliveryFunctionId: string,
  body: WithAuditDetails<PeriodicAudit>,
): AxiosPromise<ServerResponse<PeriodicAudit>> {
  return http.put(`${API_PATH_PERIODIC_AUDIT}/${deliveryFunctionId}/${body.data.id}`, body);
}
